module.exports = __webpack_public_path__ + "img/face_with_steam_from_nose.8ecf10ea.gif";